@if (linked.length > 0) {
  <ul class="linked-events" aria-label="Linked events">
    @for (event of linked; track event.id) {
      <li>
        <a
          class="linked-event"
          data-testid="linked-event-link"
          [routerLink]="calendarPath"
          [queryParams]="{ eventId: event.id }"
          [attr.aria-label]="'View ' + event.title + ' on your calendar, ' + whenLabel(event)"
        >
          <mat-icon aria-hidden="true">event</mat-icon>
          <span class="linked-event__text">
            <span class="linked-event__title">{{ event.title }}</span>
            <span class="linked-event__when">{{ whenLabel(event) }}</span>
          </span>
        </a>
      </li>
    }
  </ul>
}
